module.exports = __webpack_public_path__ + "img/dasa.c79f2aea.svg";